/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// @mui material components
import Icon from '@mui/material/Icon';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import TableHead from '@mui/material/TableHead';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';

// Material Dashboard 2 PRO React examples
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';

const initParent = {
  id: '',
  code: '',
  remark: '',
  type_id: '',
  supplier_id: '',
  discount_type: 'B',
  discount_value: '',
  shipping: '',
  discount_unit: 'Y',
  vat_id: '2',
  status: 'edit',
  print_url: '',
  created_at: '',
  updated_at: '',
};

function ReceiveCompare() {
  const mod = 'receive_list';
  const app = useSelector((state) => state[APP_STATE]);
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const [record, setRecord] = useState([]);
  const [parent, setParent] = useState(initParent);
  const [notify, setNotify] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const view = () => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/compare`, app.token, {
      id: id,
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);
      }
      setLoading(false);
    });
  };

  const classDisplay = (inp, unit) => {
    if (inp * 1 > 0) {
      return (
        <MDBox>
          <MDBox className='color-success'>{Func.numberDisplay(inp)}</MDBox>
          <MDBox>{unit}</MDBox>
        </MDBox>
      );
    }

    if (inp * 1 < 0) {
      return (
        <MDBox>
          <MDBox className='color-danger'>{Func.numberDisplay(inp)}</MDBox>
          <MDBox>{unit}</MDBox>
        </MDBox>
      );
    }

    return (
      <MDBox>
        <Icon color='info'>task_alt</Icon>
      </MDBox>
    );
  };

  // const renderList = () => {
  //   return (
  //     <MDBox>
  //       <Grid container spacing={2}>
  //         <Grid item xs={12}>
  //           <TableContainer sx={{ boxShadow: 0, minHeight: 500 }}>
  //             <Table aria-label="simple table">
  //               <TableHead>
  //                 <TableRow>
  //                   <TableCell align="center" width={20} rowSpan={2}>
  //                     No.
  //                   </TableCell>
  //                   <TableCell align="center" width={40} rowSpan={2}>
  //                     รูป
  //                   </TableCell>
  //                   <TableCell rowSpan={2}>สินค้า</TableCell>
  //                   <TableCell align="center" rowSpan={2}>
  //                     ใบสั่งซื้อ
  //                   </TableCell>
  //                   <TableCell align="center" colSpan={3}>
  //                     ราคา
  //                   </TableCell>
  //                   <TableCell align="center" colSpan={3}>
  //                     ปริมาณ
  //                   </TableCell>
  //                   <TableCell align="center" colSpan={3}>
  //                     ของแถม
  //                   </TableCell>
  //                 </TableRow>
  //                 <TableRow>
  //                   <TableCell align="right" className="nowrap">
  //                     สั่งซื้อ
  //                   </TableCell>
  //                   <TableCell align="right" className="nowrap">
  //                     รับเข้า
  //                   </TableCell>
  //                   <TableCell align="right" className="highlight-warning">
  //                     ส่วนต่าง
  //                   </TableCell>
  //                   <TableCell align="right" className="nowrap">
  //                     สั่งซื้อ
  //                   </TableCell>
  //                   <TableCell align="right" className="nowrap">
  //                     รับเข้า
  //                   </TableCell>
  //                   <TableCell align="right" className="highlight-warning">
  //                     ส่วนต่าง
  //                   </TableCell>
  //                   <TableCell align="right" className="nowrap">
  //                     สั่งซื้อ
  //                   </TableCell>
  //                   <TableCell align="right" className="nowrap">
  //                     รับเข้า
  //                   </TableCell>
  //                   <TableCell align="right" className="highlight-warning">
  //                     ส่วนต่าง
  //                   </TableCell>
  //                 </TableRow>
  //               </TableHead>

  //               <TableBody>
  //                 {record.map((row, i) => (
  //                   <TableRow key={row.id} hover>
  //                     <TableCell align="center">{i + 1}</TableCell>
  //                     <TableCell align="center">{Func.imageDisplay(row)}</TableCell>
  //                     <TableCell className="nowrap">
  //                       <MDBox>{row.code}</MDBox>
  //                       <MDBox className="cut" width={150}>
  //                         {row.name}
  //                       </MDBox>
  //                     </TableCell>
  //                     <TableCell align="center">{row.po_code}</TableCell>
  //                     <TableCell align="right">
  //                       <MDBox>{Func.numberDisplay(row.po_price)}</MDBox>
  //                       <MDBox>บาท</MDBox>
  //                     </TableCell>
  //                     <TableCell align="right">
  //                       <MDBox>{Func.numberDisplay(row.price)}</MDBox>
  //                       <MDBox>บาท</MDBox>
  //                     </TableCell>
  //                     <TableCell align="right" className="highlight-warning">
  //                       {classDisplay(row.diff_price, "บาท")}
  //                     </TableCell>
  //                     <TableCell align="right">
  //                       <MDBox>{Func.numberDisplay(row.po_quantity)}</MDBox>
  //                       <MDBox>{row.unit_name}</MDBox>
  //                     </TableCell>
  //                     <TableCell align="right">
  //                       <MDBox>{Func.numberDisplay(row.quantity_receive)}</MDBox>
  //                       <MDBox>{row.unit_name}</MDBox>
  //                     </TableCell>
  //                     <TableCell align="right" className="highlight-warning">
  //                       {classDisplay(row.diff_quantity, row.unit_name)}
  //                     </TableCell>
  //                     <TableCell align="right">
  //                       <MDBox>{Func.numberDisplay(row.po_quantity_free)}</MDBox>
  //                       <MDBox>{row.unit_name}</MDBox>
  //                     </TableCell>
  //                     <TableCell align="right">
  //                       <MDBox>{Func.numberDisplay(row.quantity_free)}</MDBox>
  //                       <MDBox>{row.unit_name}</MDBox>
  //                     </TableCell>
  //                     <TableCell align="right" className="highlight-warning">
  //                       {classDisplay(row.diff_quantity_free, row.unit_name)}
  //                     </TableCell>
  //                   </TableRow>
  //                 ))}
  //               </TableBody>
  //             </Table>
  //           </TableContainer>
  //         </Grid>
  //       </Grid>
  //     </MDBox>
  //   );
  // };

  const renderList = () => {
    return (
      <MDBox>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TableContainer sx={{ boxShadow: 0, minHeight: 500 }}>
              <Table aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell align='center' width={20} rowSpan={2}>
                      No.
                    </TableCell>
                    <TableCell align='center' width={40} rowSpan={2}>
                      รูป
                    </TableCell>
                    <TableCell rowSpan={2}>สินค้า</TableCell>
                    <TableCell align='center' rowSpan={2}>
                      ใบรับเข้าล่าสุด
                    </TableCell>
                    <TableCell align='center' colSpan={4}>
                      ราคา
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align='right' className='nowrap'>
                      ปันทุนล่าสุด
                    </TableCell>
                    <TableCell align='right' className='nowrap'>
                      รับเข้าล่าสุด
                    </TableCell>
                    <TableCell align='right' className='nowrap'>
                      รับเข้า
                    </TableCell>
                    <TableCell align='right' className='highlight-warning'>
                      ส่วนต่าง
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {record.map((row, i) => (
                    <TableRow key={row.id} hover>
                      <TableCell align='center'>{i + 1}</TableCell>
                      <TableCell align='center'>{Func.imageDisplay(row)}</TableCell>
                      <TableCell className='nowrap'>
                        <MDBox>{row.code}</MDBox>
                        <MDBox className='cut' width={150}>
                          {row.name}
                        </MDBox>
                      </TableCell>
                      <TableCell align='center'>{row.rc_code}</TableCell>
                      <TableCell align='right'>
                        <MDBox>{Func.numberDisplay(row.cost_fix)}</MDBox>
                        <MDBox>บาท</MDBox>
                      </TableCell>
                      <TableCell align='right'>
                        <MDBox>{Func.numberDisplay(row.cost)}</MDBox>
                        <MDBox>บาท</MDBox>
                      </TableCell>
                      <TableCell align='right'>
                        <MDBox>{Func.numberDisplay(row.price)}</MDBox>
                        <MDBox>บาท</MDBox>
                      </TableCell>
                      <TableCell align='right' className='highlight-warning'>
                        {classDisplay(row.diff_price, 'บาท')}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderOpen = () => {
    return (
      <Dialog
        open={modalOpen}
        maxWidth='xxl'
        keepMounted
        aria-describedby='dialog-add'
        fullWidth
        onClose={() => setModalOpen(false)}
      >
        <DialogTitle>
          เปรียบเทียบปริมาณ
          <IconButton
            aria-label='close'
            onClick={() => setModalOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>{renderList()}</DialogContent>
      </Dialog>
    );
  };

  return (
    <div>
      <MDButton
        variant='outlined'
        color='dark'
        onClick={() => {
          setModalOpen(true);
          view();
        }}
      >
        <Icon>compare</Icon>&nbsp;เปรียบเทียบ
      </MDButton>

      {renderOpen()}
      {notify}
    </div>
  );
}

export default ReceiveCompare;
